import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { IconCall } from '../easyclaim.app.assets/index';

import { IconButton, ToggleButtons, Menu, Markdown } from './index';

interface MainMenuProps {
	isOpen: boolean;
	showHelpButton: boolean;
	onClose: () => void;
	onHelpButtonClicked: () => void;
	dataPrivacyText?: string;
	dataPrivacyLink?: string;
	imprintText?: string;
	imprintLink?: string;
	hotlineNumber?: string;
	serviceTimes?: string;
}

interface MainMenuState {
	selected: JSX.Element;
}

export class MainMenu extends React.Component<MainMenuProps, MainMenuState> {
	private Buttons: JSX.Element[];

	constructor(props: MainMenuProps) {
		super(props);
		this.Buttons = this.getButtons();
		this.state = { selected: this.Buttons[0] };
		console.log(this.props.dataPrivacyText);
	}

	private getButtons() {
		const buttons = [
			<FormattedMessage id="button.dataProtection" />,
			<FormattedMessage id="button.imprint" />,
			<FormattedMessage id="button.contact" />,
		];

		if (this.props.showHelpButton) {
			buttons.push(
				<a onClick={this.props.onHelpButtonClicked}>
					<FormattedMessage id="button.help" />
				</a>
			);
		}

		return buttons;
	}

	render() {
		const buttons = this.Buttons;

		return (
			<Menu
				isOpen={this.props.isOpen}
				closeOnBackdropClick={true}
				close={this.props.onClose}
				header={
					<CenteredContainer>
						<ToggleButtons
							buttons={buttons}
							selected={this.state.selected}
							onClick={(b) => this.setState({ selected: b })}
						/>
					</CenteredContainer>
				}
			>
				<>
					{this.state.selected === buttons[0] && (
						<>
							<Container>
								<h2 className="main-menu-title">
									<FormattedMessage id="mainMenu.headline" />
								</h2>
								<DetailContainer>
									{this.props.dataPrivacyLink && (
										<>
											<Description>
												<FormattedMessage id="mainMenu.description" />
											</Description>
											<button
												onClick={(e) => {
													e.preventDefault();
													const openedWindow = window.open(
														this.props.dataPrivacyLink,
														'_blank',
														'rel=noopener noreferrer'
													);

													if (openedWindow) {
														openedWindow.opener = null;
													}
												}}
											>
												<FormattedMessage id="mainMenu.dataPrivacy" />
											</button>
										</>
									)}
									{!this.props.dataPrivacyLink && (
										// <Paragraph>
										<Markdown markdown={this.props.dataPrivacyText} escapeHtml={false} />
										// </Paragraph>
									)}
								</DetailContainer>
							</Container>
						</>
					)}
					{this.state.selected === buttons[1] && (
						<>
							<Container>
								<h2>
									<FormattedMessage id="mainMenu.imprintLink" />
								</h2>
								<DetailContainer>
									{this.props.imprintLink && (
										<>
											<Description>
												<FormattedMessage id="mainMenu.imprintDescription" />
											</Description>
											<button
												onClick={(e) => {
													e.preventDefault();
													const openedWindow = window.open(
														this.props.imprintLink,
														'_blank',
														'rel=noopener noreferrer'
													);

													if (openedWindow) {
														openedWindow.opener = null;
													}
												}}
											>
												<FormattedMessage id="mainMenu.imprintLink" />
											</button>
										</>
									)}
									{!this.props.imprintLink && (
										<Paragraph>
											<Markdown markdown={this.props.imprintText} escapeHtml={false} />
										</Paragraph>
									)}
								</DetailContainer>
							</Container>
						</>
					)}
					{this.state.selected === buttons[2] && (
						<>
							<h2>
								<FormattedMessage id="mainMenu.contact" />
							</h2>
							<ContactContainer>
								<div>
									<FormattedMessage
										id="mainMenu.contactDescription"
										values={{ hotlineNumber: <b>{this.props.hotlineNumber}</b> }}
									/>
									<br />
									<br />
									{this.props.serviceTimes || (
										<FormattedMessage id="mainMenu.contact.officeHours" />
									)}
								</div>
								<IconButton
									onClick={(e: any) => window.location.assign(`tel:${this.props.hotlineNumber}`)}
									icon={<CallIcon />}
								>
									<FormattedMessage id="button.call" />
								</IconButton>
							</ContactContainer>
						</>
					)}
				</>
			</Menu>
		);
	}
}

const Description = styled.div`
	hyphens: auto;
`;

const CallIcon = styled(IconCall)`
	height: 1.4rem;
	margin-right: 0.5rem;
	color: ${(props) => props.theme.colors.text.primary};
`;

const ContactContainer = styled.div`
	display: grid;
	grid-row-gap: 1rem;
`;

const CenteredContainer = styled.div`
	text-align: center;
`;

const Paragraph = styled.p`
	color: ${(props) => props.theme.colors.text.secondary};
	margin-bottom: 2rem;
`;

const Container = styled.div`
	color: #000;
	margin-bottom: 2rem;
`;

const DetailContainer = styled.div`
	display: grid;
	grid-row-gap: 1rem;
`;
